/**
 * 纠错操作类型
 */
export enum CorrectOpType {
    /**
     * 在old_str前新增
     */
    preAdd = 1,
    /**
     * 在old_str后新增
     */
    sufAdd = 2,
    /**
     * 删除
     */
    delete = 3,
    /**
     * 替换
     */
    replace = 4,
    /**
     * 没有操作
     */
    noAction = 16,
}

export type ICorrectResult = {
    /**
     * 在段落中的位置
     */
    index: number; // 9,
    /**
     * 在段落中的结束位置
     */
    end: number; // 10,
    /**
     * 检测到可能不通顺的字，也可能是错别字
     */
    text: string; // "文明",
    /**
     * 错误文本
     */
    old_str: string; // "文明",
    /**
     * 替换文本
     */
    repl_str: string; // "闻名",
    /**
     * 操作类型
     */
    op: CorrectOpType; // 4,
    /**
     * 建议或提示信息
     */
    sug: string; // "建议用 \"闻名\" 替换 \"文明\" ",
    /**
     * 在全文中的第几个与`text`字段相同的字符
     */
    numberTh: number; // 1,
    /**
     * 在全文中的下标
     */
    indexTotal: number; // 9,
    /**
     * 在全文中的结束位置
     */
    endTotal: number; // 10
    /**
     * 是否显示
     */
    show: boolean;
};
